// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"12":"ec1073fd","76":"2c99e13f","162":"c04f441e","355":"2aac7a6e","412":"273f1132","420":"c240007f","480":"4cbce599","511":"10407fee","546":"8d52cc39","596":"8265d7f3","681":"e8bbdef2","769":"8854b787","781":"a014f198","837":"9b314448","858":"d9d66923"}[chunkId] + ".chunk.js";
};